import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageSquare, BarChart3, FileText, Users, Shield } from 'lucide-react';

const footerLinks = {
  Product: [
    { label: 'AI Receptionist', href: '#features' },
    { label: 'Chat Agent', href: '#features' },
    { label: 'Inbound Calls', href: '#features' },
    { label: 'Outbound Campaigns', href: '#features' },
    { label: 'CRM', href: '#features' },
    { label: 'Invoicing', href: '#features' },
  ],
  Solutions: [
    { label: 'Healthcare', href: '#features' },
    { label: 'Legal Services', href: '#features' },
    { label: 'Home Services', href: '#features' },
    { label: 'Real Estate', href: '#features' },
    { label: 'Beauty & Wellness', href: '#features' },
    { label: 'HVAC & Trades', href: '#features' },
  ],
  Company: [
    { label: 'Pricing', href: '#pricing' },
    { label: 'Become an Affiliate', to: '/affiliate' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Testimonials', href: '#testimonials' },
  ],
  Legal: [
    { label: 'Terms of Service', href: '#terms' },
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Cookie Policy', href: '#cookies' },
  ],
};

const Footer = () => {
  return (
    <footer className="py-16 px-6 border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center shadow-lg shadow-purple-500/25">
                <span className="text-white font-bold text-sm tracking-tight">MD</span>
              </div>
              <span className="text-white font-medium">Miadesk</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              AI-powered front desk for growing businesses. Calls, chat, CRM, and invoicing in one platform.
            </p>
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 rounded-full bg-emerald-500" />
              <span className="text-xs text-emerald-400">All systems operational</span>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">{title}</p>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link to={link.to} className="text-sm text-gray-500 hover:text-white transition-colors" data-testid={`footer-${link.label.toLowerCase().replace(/\s+/g, '-')}`}>
                        {link.label}
                      </Link>
                    ) : (
                      <a href={link.href} className="text-sm text-gray-500 hover:text-white transition-colors" data-testid={`footer-${link.label.toLowerCase().replace(/\s+/g, '-')}`}>
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600">&copy; {new Date().getFullYear()} Miadesk. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#top" className="text-xs text-gray-500 hover:text-white transition-colors" data-testid="footer-back-to-top">
              Back to top
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
